import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'

const defaultStrings = {
  seoCompanyFormationDescription:
    'A premium same-day company formation service.',
  seoCompanyFormationTitle: 'UK Company Formation | Hoxton Mix',
}
export const companyFormationStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
